<template>
  <div class="swiper">
    <swiper v-if="promos.banners.length" :options="swiperOptions">
      <swiper-slide v-for="banner in promos.banners" :key="banner.image">
          <a :href="banner.url">
            <img class="slide" :src="banner.image"/>
          </a>
      </swiper-slide>
    </swiper>
    <div class="pagination" slot="pagination"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.pagination',
          bulletActiveClass: 'pagination__bullet_active',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="pagination__bullet ${className}"></span>`;
          },
        },
      },
    };
  },
  computed: {
    ...mapState(['promos']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.swiper {
    margin-top: -18px;
    margin-bottom: 18px;

    @include notebook {
        margin-top: 0;
        margin-bottom: 15px;
    }
}

.slide {
  max-width: 100%;
  max-height: 300px;
  object-fit: scale-down;
  display: block;
  margin: 0 auto;
}

.pagination {
    margin-top: 8px;
    text-align: center;

    &::v-deep &__bullet {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin: 0 4px;
        border-radius: 100%;
        background-color: rgba(112,128,144,0.3);
        opacity: 1;

        &:focus {
            outline: none;
        }

        &_active {
            background-color: $text-secondary;
        }
    }
}
</style>
